// extracted by mini-css-extract-plugin
export default {"content":"AddRecipe_content__cg9GB","d_card_show":"AddRecipe_d_card_show__RUggo","d_card":"AddRecipe_d_card__U7NCr"};